module.exports = __webpack_public_path__ + "img/4_139.916ddc8a.png";